import { ICompareWithSelection } from '@mg-platform/core/core-data-access'

export class DashboardGetSalesTrend {
  static readonly type = '[Dashboard] Get Sales Trends'
}

export class DashboardGetCarsAvgTicketTiresTrend {
  static readonly type = '[Dashboard] Get Cars Avg Ticket Tires Trends'
}

export class DashboardGetBenchmarkSales {
  static readonly type = '[Dashboard] Get Benchmark Sales'
  constructor(public payload: Partial<ICompareWithSelection>) {}
}

export class DashboardGetLabors {
  static readonly type = '[Dashboard] Get Labors'
  constructor(public payload: Partial<ICompareWithSelection>) {}
}

export class DashboardGetGrossProfit {
  static readonly type = '[Dashboard] Get Gross Profit'
  constructor(public payload: Partial<ICompareWithSelection>) {}
}

export class DashboardGetGoals {
  static readonly type = '[Dashboard] Get Goals'
  constructor(public payload: Partial<ICompareWithSelection>) {}
}

export class DashboardGetRanking {
  static readonly type = '[Dashboard] Get Ranking'
  constructor(public payload: Partial<ICompareWithSelection>) {}
}

export class DashboardGetAll {
  static readonly type = '[Dashboard] Get All'
  constructor(public payload: Partial<ICompareWithSelection>) {}
}
